
export default {
  name: 'FadeTransition',
};
